import { render, staticRenderFns } from "./ProgramTabSessions.vue?vue&type=template&id=5d0b850e&"
import script from "./ProgramTabSessions.vue?vue&type=script&lang=js&"
export * from "./ProgramTabSessions.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabSessions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports